import "client-only"

import { useQuery } from "@tanstack/react-query"
import { z } from "zod"

const remoteConfigParamsSignupFeResponseSchema = z.object({
  otp_enabled: z.stringbool(),
  welcome_bonus_enabled: z.stringbool().optional(),
})

type RemoteConfigParamsSignupFeResponse = z.infer<
  typeof remoteConfigParamsSignupFeResponseSchema
>

function useRemoteConfigParamsSignupFeQuery() {
  return useQuery({
    queryKey: ["remote-config-params-signup"],
    queryFn: async () => {
      // Using native fetch instead of baseClientFetcher because this endpoint doesn't
      // need the usual data enrichment
      const response = await fetch(
        `${window.APP_API_URL}/remote-config/v1/params/signup`,
        { headers: { "X-Api-Key": window.APP_FIREBASE_API_KEY } },
      )

      if (!response.ok) {
        throw new Error("Network response was not ok")
      }

      const data = await response.json()
      return remoteConfigParamsSignupFeResponseSchema.parse(data)
    },
    meta: { preventGlobalError: true },
    staleTime: Infinity,
  })
}

export { useRemoteConfigParamsSignupFeQuery }
export type { RemoteConfigParamsSignupFeResponse }
